import { staticText } from '../../../utils/translations/staticText';

const moneyHeroTranslation = staticText({
  show_all_travel_insurance_products: {
    _: 'Show All Products',
    zh: '顯示所有產品',
  },
  show_all_car_insurance_products: {
    _: 'Show All Products',
    zh: '顯示所有產品',
  },
  brand_reward: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
  brand_reward_stk_bka: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
  brand_reward_product_modal: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
  brand_reward_product_modal_cc: {
    _: 'MoneyHero Reward',
    zh: 'MoneyHero獎賞價值',
  },
});
export default moneyHeroTranslation;
